import Paper from '@mui/material/Paper';
import { makeStyles } from 'tss-react/mui';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import useMediaQuery from '@mui/material/useMediaQuery';
import Router from 'next/router';
import React from 'react';

const useStyles = makeStyles()(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.card,
  },
}));

const InboxTabs = ({ tab }) => {
  const { classes } = useStyles();
  const isMobileView = useMediaQuery('(max-width: 576px)');

  const sortingOptions = [
    {
      label: 'Unread',
      link: '/dashboard/inbox',
    },
    {
      label: `All${isMobileView ? '' : ' Replies'}`,
      link: '/dashboard/inbox/replies',
    },
    {
      label: 'Sent',
      link: '/dashboard/inbox/sent',
    },
  ];

  return (
    <>
      <Paper className={classes.root}>
        <Tabs
          centered={!isMobileView}
          fullWidth={isMobileView}
          variant={isMobileView ? 'fullWidth' : undefined}
          value={tab}
          indicatorColor="primary"
          textColor="primary"
        >
          {sortingOptions.map(topic => {
            return (
              <Tab
                key={topic.link}
                onClick={() => Router.push(topic.link)}
                label={topic.label}
              />
            );
          })}
        </Tabs>
      </Paper>
    </>
  );
};

export default InboxTabs;
